import styled from 'styled-components';

export const CheckListMenuWrapper = styled.div<{ isRTL: boolean }>`
  position: fixed;
  bottom: 24px;
  ${(props) => (props.isRTL ? 'left: 24px;' : 'right: 24px;')}
  z-index: 198;

  @media (max-width: 768px) {
    bottom: 16px;
    ${(props) => (props.isRTL ? 'left: 16px;' : 'right: 16px;')}
  }
`;

export const CheckListButton = styled.button`
  width: 50px;
  height: 24px;
  /* padding-inline-start: 5px; */
  border-radius: 8px;
  background: #303030;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(48, 48, 48, 0.4);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    /* transform: translateY(-2px); */
    /* box-shadow: 0 6px 25px rgba(48, 48, 48, 0.6); */
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 24px;
  }
`;

export const CheckListDropdown = styled.div<{ isRTL: boolean }>`
  position: absolute;
  bottom: 30px;
  ${(props) => (props.isRTL ? 'left: 0;' : 'right: 0;')}
  width: 268px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid #e9ecef;
  overflow: hidden;
  z-index: 199;
  animation: slideUp 0.3s ease-out;

  @media (max-width: 768px) {
    width: 280px;
    ${(props) => (props.isRTL ? 'left: -20px;' : 'right: -20px;')}
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const CheckListHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  padding-bottom: 0px;
`;

export const CheckListOption = styled.div`
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    /* transform: translateY(-1px); */
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  }
  button {
    align-self: flex-end;
    border-color: #303030;
    color: #303030;
    width: 100%;
  }
`;

// Animation keyframes
export const fadeIn = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const slideIn = `
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;
